import { notEmpty, getNameProp } from "../modules/utilities"
import { BASE, CATEGORY, RADIO, TAB, TABLE_BIT, TENSE_ENUM } from "../modules/constants"
import { CHECKBOX } from "../modules/checkbox_constants"
import HOOK from "../components/hooks"

export const getOrderSet = props => {
    // console.log('getOrderSet props:', props)
    const { checkboxes, portrait, radio, tabIndex } = props
    let orderSet = 0
    orderSet = orderSet | (portrait ? TABLE_BIT.PORTRAIT : 0)

    const isCompanyBoardOrConnections = tabIndex === TAB[BASE.COMPANY].INDEX &&
        (radio[BASE.COMPANY] === RADIO[BASE.COMPANY].BOARD || radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS)
    const isPersonRolesOrConnections = tabIndex === TAB[BASE.PERSON].INDEX &&
        (radio[BASE.PERSON] === RADIO[BASE.PERSON].ROLES || radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS)

    // 'Company Board' and 'Person Roles' have several 'orderSet's because the table columns
    // vary depending on the status of the 'tense' checkboxes selected, and whether 'Connections' is selected
    if (isCompanyBoardOrConnections || isPersonRolesOrConnections) {
        const showSecondDegree = tabIndex === TAB[BASE.COMPANY].INDEX
            ? radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
            : radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS
        orderSet = orderSet | (showSecondDegree ? TABLE_BIT.CONNECTIONS : 0)
        orderSet = orderSet | (!!(CHECKBOX[HOOK.TENSE][TENSE_ENUM.NOTICE].BIT & checkboxes[HOOK.TENSE]) ? TABLE_BIT.RESIGNED : 0)
        orderSet = orderSet | (!!(CHECKBOX[HOOK.TENSE][TENSE_ENUM.PAST].BIT & checkboxes[HOOK.TENSE]) ? TABLE_BIT.RESIGNED : 0)
    }

    return orderSet
}

export const getNodeConnectionsCount = ({ node, tense }) => {
    // Get the number connections. TODO: Does not take into account
    // that some of the connections might be filtered out!! (sex, role etc)
    const { connectionCounts } = node

    return (tense[TENSE_ENUM.PAST] ? connectionCounts.connections.total.past : 0) +
        (tense[TENSE_ENUM.CURRENT] ? connectionCounts.connections.total.current : 0) +
        (tense[TENSE_ENUM.FUTURE] ? connectionCounts.connections.total.future : 0)
}

export const getEntityById = (entities, ids) => {
    // console.log('getEntityById ids:',ids)
    // Test each id in ids to see if it has a matching pointer
    // Returns matching entity or undefined
    let entityId = ""

    ids.every(id => {
        entityId = entities.pointers[id]
        return entityId === undefined
    })

    return entityId !== undefined ? entities.items[entityId] : undefined
}

// Find entity in entities using item.companyProps.lse.lei match
export const getEntityByLei = (entities, lei) =>
    Object.values(entities.items).find(obj => obj.companyProps?.lse?.lei === lei)

export const mergeIds = (ids1, ids2) => {
    return [...new Set([...ids1, ...ids2])]
}

export const processNewEntities = (existingEntities, newEntities, uriId, favourites) => {
    createOrUpdateEntities(existingEntities, newEntities, uriId, favourites)
    mapConnectionIds(existingEntities.pointers, newEntities.connections)
    createConnections(existingEntities, newEntities.connections)
}

const createOrUpdateEntities = (existingEntities, newEntities, uriId, favourites) => {

    newEntities.items.forEach(newEntity => {
        // console.log(`newEntity: `, newEntity)
        let existingEntity = getEntityById(existingEntities, newEntity.ids)

        // If no entity matches Ids, try to find one with matching name (and category)
        if (existingEntity === undefined)
            existingEntity = matchEntityByProps(existingEntities, newEntity)

        if (existingEntity !== undefined) { // Does the entity exist? YES
            // console.log(`existingEntity: `, existingEntity)
            updateEntity(existingEntity, newEntity)
            updatePointers(existingEntities, newEntity, existingEntity.entityId)

        } else { // Does the entity exist? NO
            // Get a new entity id
            let entityId = getNewId("entity", getNameProp.toSort(newEntity.name))
            newEntity.entityId = entityId

            // Does the entity we are adding have an id that matches our uriId
            // If so, we must revise the newEntity's ids with those in uriId
            let match = false
            uriId.split(',').every(id1 => {
                return (newEntity.ids.every(id2 => {
                    match = id1 === id2
                    return !match
                }))
            })

            if (notEmpty(favourites))
                setIsFavourite(newEntity, favourites)

            // Add the new entity to the existing entities
            existingEntities.items[entityId] = newEntity

            updatePointers(existingEntities, newEntity, entityId)
        }
    })
}

const createConnections = (existingEntities, newConnections) => {

    newConnections.forEach(newConnection => {

        var connectionId =
            existingEntities.items[newConnection.parentId].connectionIds[newConnection.childId]

        if (connectionId) { // Does the connection exists? YES

            let newCapacities = newConnection.capacities
            let existingConnection = existingEntities.connections[connectionId]

            for (var newCapacityKey in newCapacities) {
                // newCapacityKey possible values: "Officer", "PersonsWithSignificantControl"

                let newCapacity = newCapacities[newCapacityKey]
                let existingCapacityRoles = existingConnection.capacities[newCapacityKey]

                if (existingCapacityRoles) { // Does the capacity exists? YES

                    newCapacity.forEach(role => {
                        if (doesRoleExist(existingCapacityRoles, role) === false) // Does the role exist? NO
                            existingCapacityRoles.push(role) // Add the role to the existing capacity roles
                    })

                } else  // Does the capacity exists? NO
                    existingConnection.capacities[newCapacityKey] = newCapacity
            }
        } else { // Does the connection exists? NO

            // console.log(`newConnection: `, newConnection)
            connectionId = getNewId("connection", newConnection.childId.slice(4, 11))
            createConnection(existingEntities, connectionId, newConnection.parentId, newConnection.childId, newConnection.capacities)
        }
    })
}

const matchEntityByProps = (entities, newEntity) => {
    // Returns the existing entity whos category, name and postcode
    // match the newEntity; or undefined is no match found.
    // console.log("matchEntityByProps newEntity: ", newEntity);
    let entityId

    if (entities.items) {
        if (newEntity.category === CATEGORY.COMPANY) {
            for (entityId in entities.items) {
                let entity = entities.items[entityId]
                if (entity.category === CATEGORY.COMPANY &&
                    entity.name.original === newEntity.name.original &&
                    !(entity.companyProps.number && newEntity.companyProps.number)) {
                    // NB: If both have a company number, then one must have been dissolved
                    // console.log('entity:', entity)
                    return entity
                }
            }
        } else { // category === "person"
            if (newEntity.address && newEntity.address.postalCode) {
                for (entityId in entities.items) {
                    let entity = entities.items[entityId]
                    if (entity.category === CATEGORY.PERSON &&
                        entity.name.toMatch === newEntity.name.toMatch &&
                        datesOfBirthNotDifferent(entity.personInfo.dateOfBirth, newEntity.personInfo.dateOfBirth) &&
                        entity.address.postalCode === newEntity.address.postalCode) {
                        return entity
                    }
                }
            }
        }
    }

    return undefined
}

const newId = {
    connection: 10000,
    entity: 10000,
    pointer: 10000
}

export const getNewId = (type, name) => {
    let prefix = (newId[type]++).toString().slice(1)
    let suffix = name?.slice(0, 5).replace(/ /g, '_')
    return `${prefix}_${suffix}`
}

const updateEntity = (existingEntity, newEntity) => {
    // Replace any properties that don't exist or are null
    // with those of the new entity (which may also be null)
    // console.log('existingEntity, newEntity:', existingEntity, '  : ', newEntity)
    if (existingEntity.personInfo && newEntity.personInfo) {
        for (var prop in newEntity.personInfo)
            existingEntity.personInfo[prop] = existingEntity.personInfo[prop] ?? newEntity.personInfo[prop]
    }

    if (newEntity.companyProps?.companyProfile)
        existingEntity.companyProps = newEntity.companyProps

    for (var prop in newEntity) {
        if (!existingEntity[prop])
            existingEntity[prop] = newEntity[prop]
    }

    existingEntity.entityStatus = newEntity.entityStatus
    existingEntity.ids = mergeIds(existingEntity.ids, newEntity.ids)
}

const updatePointers = (existingEntities, newEntity, entityId) => {
    // The entity may have more than one id so add pointers from
    // each id in ids to the entity to entityId
    // NB. It's not a problem is they already exist!
    newEntity.ids.forEach(id => existingEntities.pointers[id] = entityId)
}

const mapConnectionIds = (pointers, connections) => {
    // Swaps parent and child ids (companyNumber & officerId) for the internal ids using the pointers

    connections.forEach(connection => {

        //#region for development: This should not happen!
        if (pointers[connection.parentId] === undefined ||
            pointers[connection.childId] === undefined) {
            console.log(`connection: `, connection);
            console.log(`pointers: `, pointers);
            throw new Error('Invalid connection. Pointer(s) undefined')
        }
        //#endregion

        connection.parentId = pointers[connection.parentId]
        connection.childId = pointers[connection.childId]
    })
}

export const setIsFavourite = (entity, favourites) => {
    if (notEmpty(favourites)) {
        if (entity.category === CATEGORY.COMPANY)
            setIsFavourite2(entity, favourites.companies)
        else
            setIsFavourite2(entity, favourites.people)
    }
}

const setIsFavourite2 = (entity, favouriteItems) => {
    const { isFavourite, _id } = isFavourite3(entity, favouriteItems)
    entity.isFavourite = isFavourite
    entity._id = _id
}

const isFavourite3 = (entity, favouriteItems) => {
    let index = -1
    var _id = null
    // use 'every' to loop while return is true
    favouriteItems.every(favourite => {
        return entity.ids.every(id => {
            index = favourite.ids.indexOf(id)
            _id = favourite._id
            return index === -1
        })
    })

    const isFavourite = index > -1
    return { isFavourite, _id: isFavourite ? _id : entity._id }
}

const doesRoleExist = (roles, newRole) => {
    return roles.findIndex(role => (
        role.roleType === newRole.roleType &&
        dateWithoutTime(role.from) === dateWithoutTime(newRole.from) &&
        (role.until == null || newRole.until == null ||
            dateWithoutTime(role.until) === dateWithoutTime(newRole.until))
    )
    ) > -1
}

const dateWithoutTime = date => date ? date.slice(0, 10) : null

const createConnection = (entities, connectionId, parentId, childId, capacities) => {
    // Add a new connection to the entities.connections
    entities.connections[connectionId] = { parentId, childId, capacities }

    // Add the connectionId to the connected entities
    entities.items[parentId].connectionIds[childId] = connectionId
    entities.items[childId].connectionIds[parentId] = connectionId
}

const datesOfBirthNotDifferent = (dobA, dobB) => {
    return dobA === null || dobB === null
        ? true
        : dobA.day === dobB.day &&
        dobA.month === dobB.month &&
        dobA.year === dobB.year
}

